import React, {useRef, useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";

import "antd/dist/antd.css"

import { Button, Checkbox, Form, Input, Modal, Select, Steps } from "antd";
import { firebase_auth, firebase_database, firestore } from "./utils/database";


import {conf_ID, getConferenceContent} from "./utils/misc";

import SearchProfile from "./SearchProfile";

import PaperPick from "./PaperPick";

import {
    MinusCircleTwoTone,
    PlusCircleTwoTone
  } from "@ant-design/icons";

const { Option } = Select;
const { Step } = Steps;

const DataCollection: React.FC = () => {
    const auth = useSelector((state) => state.auth);

    const [current, setCurrent] = useState(0);
    const [selectedMatch, setSelectedMatch] = useState([]);
    const [searchMatch, setSearchMatch] = useState([]);
    const [consented, setConsented] = useState(false);
    const [name, setName] = useState("");
    const [affiliation, setAffiliation] = useState("");
    const [email, setEmail] = useState("");
    const [stage, setStage] = useState("undergraduate");
    const [token, setToken] = useState("");
    const [prev_papers, setPrevPapers] = useState({});
    const [ssUrl, setSsUrl] = useState([]);
    const [my_liked_contents, setMy_liked_contents] = useState([]);
    const [isPaperModal, setIsPaperModal] = useState(false);
    const [myLikeIds, setMyLikesIds] = useState([]);



    const prev = () => {
        setCurrent(current - 1);
    };

    const next = () => {
        setCurrent(current + 1);
    };

    useEffect(() => {
        async function fetchSettings() {
            const data = await getSettings();

            console.log(data);
            if(data) setConsented(true);
            if(data && data.name) setCurrent(1);
            if(data && data.token) setCurrent(2);
        }
        

        fetchSettings();

        const acmToken = getUrlParameter("token");

        if(!acmToken) return; 

        setToken(acmToken);
        window.history.replaceState(null, null, window.location.pathname);
        
        async function fetchData() {
            const my_liked = await getLikedContent(acmToken);
            
            console.log(my_liked);

            let my_liked_ids = [];
            if (my_liked['myLists'].length) {
              my_liked_ids = my_liked['myLists'][0]['myListItems'].filter(p => p.conferenceId === conf_ID).map(p => p.contentId);
              console.log(my_liked_ids);
          
            }
          
            my_liked_ids = my_liked_ids.concat( my_liked['myScheduleSessions'].filter(p => p.conferenceId === conf_ID).map(p => p['myScheduleContents']).flat().map(p => p['contentId']) );
            console.log(my_liked_ids)
            
            fetchMy_liked_contents(my_liked_ids);
            

           
        }

        fetchData();
        
    }, [])

    const fetchMy_liked_contents = async (my_liked_ids) => {
        const pub_content =  await getConferenceContent();
        console.log("pub_content", pub_content);
      
        const my_liked_contents = pub_content.filter(p => my_liked_ids.includes(p.id + ""));
        console.log("my_liked_contents", my_liked_contents);
        console.log(my_liked_contents.filter(p => !p['abstract']));
        setMy_liked_contents(my_liked_contents);
    }

    const getSettings = async () => {
        // get the settings data from firestore collection
        const settings = await firestore.collection("responses")
                        .doc(firebase_auth.currentUser.uid)
                        .get();

        // if the data exist, save it as state
        if (settings.exists) {
            const data = await settings.data();

            // render the stored data
            // setAffiliation(data.affiliation);
            setEmail(data.email)
            setName(data.name);
            setPrevPapers(data.prev_papers);
            if(data.token) setToken(data.token);

            return data;
        }
    }
    

    // load what papers that I like from CHI 2022
    const getLikedContent = async (soya_token) => {
        let author_url = `https://api.sigchi.org/api/cloud/external/read/all`;
                
                return fetch(author_url, {
                    method: 'POST',
                    body: JSON.stringify({ lastSyncDate: 0 }),
                    headers: {
                        "Sigchi-User-Token": soya_token,
                        "Public-App-Signature": "client: Name, app: 1.0",
                        'Content-Type': 'application/json',
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }).then(res => res.json())
                .then(result => {
                    // const entities = formatSearchResult(result).flat();
                    // handleSearchMatchChange(entities);
                    return result;
                });
    };

    const getUrlParameter = (sParam) => {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    const onConsent = (values: any) => {
        console.log("Success:", values);
        const ref = firestore.collection("responses").doc(firebase_auth.currentUser.uid);
        
        ref.set(values, {merge: true});
        
        setConsented(true);
    };

    const onFinish = (values: any) => {
        console.log("Success:", values);
        const ref = firestore.collection("responses").doc(firebase_auth.currentUser.uid);
        
        if(current == 0) {
            debugger;
            ref.set(values, {merge: true});
            
            setName(values['name']);
            setStage(values['stage']);
            setEmail(values['email'])
        }
        else if (current == 1) {
            if(myLikeIds.length < 2) {
                alert("Please log in to your ACM account");
                return;
            } else if(!my_liked_contents.length) {
                alert("You didn't add any paper to your list in the SIGCHI program. Please add papers and reload.");
                return;
            }
            ref.set({token: token, myLikeIds: myLikeIds},  {merge: true})
        }
        else if (current == 2) {
            ref.set({prev_papers: prev_papers, ssUrl: ssUrl}, {merge: true});

            setPrevPapers({});
            setSearchMatch([]);
            setSelectedMatch([]);
        } else {
            ref.set({advisor_papers: prev_papers}, {merge: true});
            
            setTimeout(function(){ window.location = "/label?id=" + firebase_auth.currentUser.uid}, 3500);

        }
        

        next();
    };


    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    const handleChange = (value: string) => {
        console.log(`selected ${value}`);
    };

    const removeSelectedMatch = (e) => {
        const v = e.currentTarget;

        // id of the entry to be deleted
        const entryId = parseInt(v.id.substring(6,))

        // delete the entry from the current selectedMatch array
        const newSelectedMatch = selectedMatch.filter((v, index) => v.id !== ""+entryId);

        // render the new selectedMatch array
        setSelectedMatch(newSelectedMatch);

        // remove the deleted author's papers
        let ref = firestore.collection("responses").doc(firebase_auth.currentUser.uid);
        
        let leftPaper = {};
        for (const [key, paper] of Object.entries(prev_papers)) {
            if(paper["author_mag_id"] === ""+entryId) continue;
            leftPaper[key] = paper
        }
        ref.update(leftPaper);
        setPrevPapers(prev_papers);
        
        setSsUrl( ssUrl.filter(item => item !== ""+entryId) );
    }

    const addSelectedMatch = (e) => {
        const v = e.currentTarget;

        // id of the entry to be added
        const entryId = parseInt(v.id.substring(6,))

        // select entry to be added from searchMatch array
        const entry = searchMatch.filter(e => e.id === "" + entryId)[0];

        // add the entry to the current selectedMatch array
        const newSelectedMatch = [...selectedMatch, entry];

        // render the new selectedMatch array
        setSelectedMatch(newSelectedMatch);

        // setName(entry["name"]);

        // add recent papers from MAG that will be shown in the user's profile
        let query_url= `https://api.semanticscholar.org/graph/v1/author/${entry.id}?fields=name,papers.authors,papers.title,papers.url,papers.year,papers.journal,papers.fieldsOfStudy,affiliations,paperCount`;
        fetch(query_url, {
            headers: {
                // 'Ocp-Apim-Subscription-Key': process.env.REACT_APP_MAG_SUB_KEY,
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': 'DIjEjQlI8x2zjnYM6Ehgw9jIsGnYl0ql86pat70w'
            }
        })
        .then(res => res.json())
        .then(paper_list => {
            // process the recent papers
            let papers = {};
            const non_arxivs = paper_list["papers"] // .filter(p =>  !("VFN" in p && p["VFN"].includes("arXiv")));
            if(true) {
                non_arxivs.sort((a,b) => b.year - a.year);
                non_arxivs.slice(0,5).map(p => {
                    papers[p["paperId"]]= {
                        "author_mag_id": entry.id, 
                        "title": p["title"],
                        "authors": p["authors"].map(a => { 
                            return {
                                "name": a["name"],
                                "authorId": a["authorId"]
                            };
                    }),
                        "year": p["year"],
                        "conference": p["journal"]? (p["journal"]["name"] || "") : ""
                    }
                    return null;
                })

                
            }
                
            console.log(firebase_auth.currentUser);
            firestore.collection('responses').doc(firebase_auth.currentUser.uid).set({"prev_papers": papers}, {merge:true});
            setPrevPapers({...papers, ...prev_papers});

            const s_urls = [...new Set([...ssUrl ,...[entry.id]])];;
            setSsUrl(s_urls);
        })
    }

    const handleSearchMatchChange = (newSearchMatch) => {
        // render new search results
        setSearchMatch(newSearchMatch);
    }

    const infoForm = () => {
        if (current == 0)
        return (
            <Form name="basic" onFinish={onFinish} onFinishFailed={onFinishFailed} initialValues={{
                name: name,
                stage: stage,
                email: email,
              }}>
            <Form.Item
                label="Your full name"
                name="name"
                value={name}
                rules={[{ required: true, message: "Please input your full name!" }]}
            >
                {/* TODO: make this as a select allowing dynamic addition */}
                <Input placeholder="Harry Potter" />
            </Form.Item>

            {/* <Form.Item
                label="Affliation"
                name="affliation"
                value={affiliation}
                rules={[{ message: "Please input your affliation!" }]}
            >
                <Input placeholder="Hogwarts University" />
            </Form.Item> */}
            <Form.Item label="I'm" name="stage">
                <Select>
                    <Option value="undergraduate">a undergraduate student</Option>
                    <Option value="graduate">a graduate student</Option>
                    <Option value="postdoc">a post-doc researcher</Option>
                    <Option value="faculty">a faculty member</Option>
                    <Option value="industry">in industry</Option>
                    <Option value="other">other</Option>
                </Select>
            </Form.Item>
            <Form.Item
                label="Your email"
                name="email"
                value={email}
                rules={[{ message: "Please input your email!" }]}
            >
                <Input placeholder="your@email.com" />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                Next
                </Button>
            </Form.Item>
            </Form>
        );
        else return `${name} `;//`${name} at ${affiliation}`;
        // <div>
        //   <label for="name">Your name: </label><input id="name" type="text" placeholder="This will be displayed to other users" />
        //   <label for="affliation">Your affliation: </label><input id="affliation" type="text" placeholder="This will be displayed to other users" />
        //   {current === 0 && nextBtn}</div>
    };

    const profilePick = () => {
        if (current == 2)
        return (
            <>
            <SearchProfile 
                name={name}
                searchMatch={searchMatch}
                selectedMatch={selectedMatch}
                addSelectedMatch={addSelectedMatch}
                removeSelectedMatch={removeSelectedMatch}
                handleSearchMatchChange={handleSearchMatchChange}
            />
            <br />
            <span>Skip if you don't have profile by clicking Next.</span>
            <br />
            <Button type="default" onClick={prev}>
                Previous
            </Button>
            <Button type="primary" onClick={onFinish}>
                Next
            </Button>
            </>
        );
    };

    const interestLoad = () => {
        if (current == 1) return <>
            <span>Are you using SIGCHI app to mark your paper interest? </span><br/>
            <Button type="primary" onClick={() => setIsPaperModal(true)}>
                Mark papers you are interested in here
            </Button>
             or 
            <Button type="primary">
                <a href="https://programs.sigchi.org/login?clientId=b4c00fab-fc1d-4952-aae3-6caa4db11370&callback=https:%2F%2Facademic-matching.netlify.app">Import papers you marked in the SIGCHI program app</a>
            </Button>
            <p>{token && "Your papers in the list is successfully loaded. "}</p>
            {my_liked_contents.length > 0 && <><h1>Some papers that you liked</h1>
                <ul>
                    {my_liked_contents.length ? my_liked_contents.slice(0, 5).map(p => <li>{p['title']}</li>): <li>You don't have any paper marked. Please go <a target="_blank" rel="noopener noreferrer" href="https://programs.sigchi.org/chi/2022/program/2-may">here</a>, like a few papers, and try again! </li> }
                    
                </ul></>}
            
            <Button type="default" onClick={prev}>
                Previous
            </Button>
            <Button type="primary" onClick={onFinish}>
                Next
            </Button></>;
    };

    const advisorPick = () => {
        if (current == 3)
        return (
            <>
            <SearchProfile 
                searchMatch={searchMatch}
                selectedMatch={selectedMatch}
                addSelectedMatch={addSelectedMatch}
                removeSelectedMatch={removeSelectedMatch}
                handleSearchMatchChange={handleSearchMatchChange}
                advisor={true}
            />
            <br />
            <Button type="default" onClick={prev}>
                Previous
            </Button>
            <Button type="primary" onClick={onFinish}>
                Next
            </Button>
            </>
        );
    };

    const onChange = (value: number) => {
        console.log("onChange:", current);
        setCurrent(value);
    };

    return (
        <>
        {consented? 
            <Steps direction="vertical" current={current}>
                <Step title="Your infomation" description={infoForm()} />
                <Step title="Your interest" description={interestLoad()} />
                <Step title="Your acdemic profile" description={profilePick()} />
                <Step title="Your advisor's acdemic profile" description={advisorPick()} />
                <Step title="Your choice of researchers" description={current == 4 && <span>Redirect to the next page in 3 seconds <Button type="primary" href={"/label?id=" + firebase_auth.currentUser.uid}>Go now</Button></span>} />
            </Steps>
            :
            <div>
            <h3>Consent</h3>
            <p>Our Haystack research group (https://haystack.csail.mit.edu) at MIT seek information from you to help us develop and test algorithms for helping to match researchers based on their interests.   Specifically, we seek access to:
            <br/>
            * your profile on semantic scholar, to tell us which papers you have published and cited<br/>
            * information in the SIGCHI program app about which papers you have marked to attend at conferences or for your reading list<br/>
            If you give consent, our small app will take you through the process of indicating your identity on these two platforms, and giving permission for us to fetch the above data from them.   Our access will be read-only; we will not be able to change data on either platform.   You may revoke your permission to access this data at any time by emailing soya@mit.edu.</p>
            <Form onFinish={onConsent} style={{"marginLeft": "100px", "marginRight": "100px"}} initialValues={{
                share_consent: false,
                publish_consent: false,
              }}>
                <Form.Item
                    name="share_consent"
                    valuePropName="checked"
                    rules={[
                    {
                        validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(new Error("We need your permission. If you don't consent, feel free to stop here.")),
                    },
                    ]}
                    style={{marginBottom: "30px"}}
                >
                    <Checkbox>
                        I give permission for the Haystack group to access and make use of my data to analyze academic matchmaking algorithms and interfaces.
                    </Checkbox>
                </Form.Item>
                <Form.Item
                    name="publish_consent"
                    valuePropName="checked"
                >
                    <Checkbox>
                        I give permission for the Haystack group to publish my data so that others researching academic matchmaking algorithms can make use of it (if you revoke this permission, we will stop publishing your data but cannot take it away from others who have downloaded it).   
                    </Checkbox>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Proceed
                    </Button>
                </Form.Item>
            </Form>
            <Input id="regcode" style={{float:"left", width: "200px", display: "none"}} />
        </div>}
        <Modal width={600} closable={false} visible={isPaperModal} footer={[
            <Button key="submit" type="primary" disabled={myLikeIds.length < 2} onClick={async () => {
                setIsPaperModal(false);fetchMy_liked_contents(myLikeIds)}}>
              Ok
            </Button>
          ]}>
            <PaperPick likes={myLikeIds} setLikePapers={setMyLikesIds} />
        </Modal>
        </>
    );
};


export default DataCollection;